module.exports = __webpack_public_path__ + "public/images/icon-heart.bbd3c4e287296cb52eaef16075485382.svg";